const carouselItems = [
  {
    title: '暑期档必追 · 高分悬疑剧精选',
    desc: '烧脑反转不断，每一集都是高能预警。从国产口碑黑马到国际获奖神作，为你挑选这个夏天最值得追的悬疑佳作。',
    tag: '悬疑烧脑',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20mystery%20thriller%20atmosphere%20with%20dramatic%20lighting%20and%20shadows%2C%20film%20noir%20aesthetic%2C%20detective%20silhouette%20against%20a%20rainy%20cityscape%20at%20night%2C%20warm%20golden%20street%20lamp%20reflections%2C%20moody%20and%20intense%20visual%20style%2C%20cinematic%20composition%2C%20deep%20contrast%20with%20dark%20blues%20and%20warm%20highlights&width=800&height=500&seq=carousel-suspense-001&orientation=landscape',
  },
  {
    title: '古装仙侠宇宙 · 经典与新作齐飞',
    desc: '从经典仙剑到最新玄幻巨制，古装仙侠题材持续霸屏。沉浸式东方美学，每一帧都是壁纸级画面，带你走进瑰丽奇幻的仙侠世界。',
    tag: '古装仙侠',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20ancient%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%20and%20waterfalls%2C%20flowing%20silk%20robes%20in%20soft%20light%2C%20traditional%20Chinese%20architecture%20in%20mist%2C%20warm%20golden%20sunset%20light%2C%20cinematic%20widescreen%20composition%2C%20dreamy%20atmospheric%20lighting%2C%20soft%20pastel%20color%20palette&width=800&height=500&seq=carousel-fantasy-002&orientation=landscape',
  },
  {
    title: '韩剧控必看 · 口碑炸裂高分合集',
    desc: '复仇爽剧、治愈温情、悬疑惊悚，韩剧总能精准击中观众的情绪开关。精选近年来豆瓣8.5分以上高分韩剧，一刷就停不下来。',
    tag: '韩剧精选',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20Korean%20drama%20aesthetic%20scene%20with%20soft%20natural%20light%20through%20a%20cafe%20window%2C%20two%20people%20having%20an%20emotional%20conversation%20at%20a%20wooden%20table%2C%20autumn%20leaves%20visible%20outside%2C%20cinematic%20depth%20of%20field%2C%20warm%20golden%20hour%20lighting%2C%20intimate%20romantic%20atmosphere%2C%20soft%20color%20grading&width=800&height=500&seq=carousel-kdrama-003&orientation=landscape',
  },
  {
    title: '动漫燃爆 · 这个夏天最热的番剧',
    desc: '热血战斗、治愈日常、烧脑智斗，动漫世界永远有无限惊喜。从现象级霸权番到独立动画精品，二次元的快乐等你来解锁。',
    tag: '动漫番剧',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20cityscape%20at%20sunset%20with%20dramatic%20colorful%20sky%2C%20dynamic%20energy%20waves%20in%20warm%20orange%20and%20golden%20tones%2C%20silhouette%20of%20a%20character%20standing%20on%20a%20rooftop%2C%20cinematic%20wide%20angle%20composition%2C%20inspirational%20and%20uplifting%20mood%2C%20rich%20warm%20color%20palette%20with%20soft%20gradients&width=800&height=500&seq=carousel-anime-004&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
          精选专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精心策划的追剧专题，发现更多值得一看的好内容
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item, index) => (
            <div
              key={index}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200 transition-all duration-300 hover:shadow-md cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}